module.exports = __webpack_public_path__ + "img/摄图网_501010724_banner.be04412f.png";